import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "comp-item ln-glass" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(['mdi', _ctx.icon])
    }, null, 2),
    _createElementVNode("div", null, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", { innerHTML: _ctx.description }, null, 8, _hoisted_2)
    ])
  ]))
}